import { call, put, takeEvery } from "redux-saga/effects";
import axios from "axios";
// Login Redux States
import { LOGIN_USER, LOGOUT_USER } from "./actionTypes";
import { apiError, loginSuccess, logoutUserSuccess,showDialog } from "./actions";
import { BACKEND_URL_LOG,MACKESSON_URL_AUTH ,BACKEND_URL_PORTAIL, CLIENT_ID} from "../../../config/const";
import { ErrorMessage } from "formik";
import { initSessionManager, clearSessionManually } from '../../../helpers/sessionManager';
import { markSessionValid, resetSessionCheck } from '../../../helpers/sessionValidation';


import pkceChallenge from "pkce-challenge";
//Include Both Helper File with needed methods
//import {  postFakeLogin,  postJwtLogin,  } from "../../../helpers/fakebackend_helper";
   const loginOcta = async (email) => {
    localStorage.setItem("authMethod", "okta");

    // 1. Generate PKCE pair 
    const pkceChallengevalue = pkceChallenge(44);
    const code_verifier = (await pkceChallengevalue).code_verifier;
    const code_challenge = (await pkceChallengevalue).code_challenge;
    const state = Math.random()
      .toString(36)
      .substr(2);
    const datapkce = {
      state: state,
      code_verifier: code_verifier,
    };
    axios.post(
      BACKEND_URL_PORTAIL+"auth/pkce",
      datapkce
     
    );

    // 3. Build and navigate to Okta’s authorize endpoint
    const params = new URLSearchParams({
      client_id: CLIENT_ID,
      redirect_uri:BACKEND_URL_PORTAIL+"okta/callback",
      response_type: "code",
      scope: "openid profile email",
      state: state,
      code_challenge: code_challenge,
      code_challenge_method: "S256",
      login_hint:        email,  
      prompt:           'login'     
    });

    window.location.assign(
      MACKESSON_URL_AUTH+`?${params}`
    );
  }; 
function* loginUser({ payload: { user, history } }) {
  
  try {
        const isOkta = yield call(axios.get, BACKEND_URL_PORTAIL +"api/checkUserOktaByUsername/" + user.username);
        if(isOkta.isOkta)
        {
            loginOcta(isOkta.email);
        }
        else {
  // Perform the login API call
    const response = yield call(axios.post, BACKEND_URL_PORTAIL + "api/login", {
      lang: localStorage.getItem("lang"),
      username: user.username,
      password: user.password,
    });

    //initSessionManager();
    
         const dataEmail= {
          mode: 'mail',
          lang: localStorage.getItem("lang")?localStorage.getItem("lang"):"en"
        }
  if(response.mfa_required)
  {
      const tempToken = response.temp_token;
      // store temporarily (e.g. Redux or local state)
      localStorage.setItem("SET_TEMP_TOKEN", tempToken);
      const config = {
      headers: {
        'Content-Type': 'application/json',
        'X-MFA-Token': tempToken, // <-- important
      },
    };

      const hasDMFA = yield call(axios.post, BACKEND_URL_PORTAIL + "api/sendCode2FA",dataEmail,config);
      
     history("/MFA") 
  }
  else {
   const config = {
    headers: {
      Authorization: `Bearer ${response.token}`,
    },
  };
   // Save response data to localStorage
        localStorage.setItem("authUser", JSON.stringify(response.token));
        localStorage.setItem("token", response.token);
        // Le token vient d'etre valide par le back-office : on evite une
        // verification supplementaire (et l'ecran de chargement associe)
        // lors de la navigation vers /home.
        markSessionValid();
 
        
    
      if (response.message === 2) {
        const errorMessage = "AccountLocked" ;
        console.log('error: ', errorMessage);
      
        yield put(apiError(errorMessage));
        yield put(showDialog(errorMessage, true));
      
        return;
      }
      
       const response2 = yield call(axios.get, BACKEND_URL_LOG + "verifGroup", config);
    if (response2.isValid) {
        // Dispatch a login success action
        yield put(loginSuccess(response.token));

        // Dispatch success message
        yield put(showDialog('loginSuccessful', false));

        // Perform additional functions after a successful login
        const whereToGo= yield call(handlePostLoginTasks, response,user.username);
        // Navigate to the dashboard
        history(whereToGo)
    }else{
       yield put(apiError('invalidUsernamePassword'));

      yield put(showDialog('invalidUsernamePassword', true));
    }
  }
 
        }
  
  } catch (error) {
    console.log('error: ', error);
 // Assurons-nous d'avoir toujours un message d'erreur

 //const errorMessage = error =='Request failed with status code 401' ? 'invalidUsernamePassword' : 'anErrorOccurredDuringLogin';
  const errorMessage = 'invalidUsernamePassword'
 // Dispatch an error action
   yield put(apiError(errorMessage));

    // Dispatch error message
    yield put(showDialog(errorMessage, true));
  }
}
function* handlePostLoginTasks(response,userName) {
  try {
    const config = { 
      headers: {
        Authorization: `Bearer ${response.token}`,
      },
    };
    
    // Example: Fetch user profile data
    const userInfo = yield call(axios.get, BACKEND_URL_PORTAIL + "api/getUserInfos",config);
    //yield put(setUserProfile(userProfile));
    localStorage.setItem('idUser', userInfo.userInfo.Id);
    localStorage.setItem('username', userInfo.userInfo.UserName);
    localStorage.setItem('lastFailedLogin',userInfo.userInfo.lastFailedLogin!=null?userInfo.userInfo.lastFailedLogin:"null");
    localStorage.setItem('passwordChange',userInfo.userInfo.passwordChange);
    if (localStorage.getItem('passwordChange') === 'true') {
      return'/change-password-new';
    } 
    else   if (localStorage.getItem('passwordChange') === 'true' && localStorage.getItem('lastFailedLogin') != "null") {
      return'/change-password-unblocked';
    }else{
   
       return "/home"
      }
     
    
      
    
    // Example: Perform other tasks like fetching initial app data
   

    // Add any other functions you want to call after a successful login
  } catch (error) {
    console.log('Post-login tasks failed:', error);
    // Handle any errors in the additional tasks
  }
}

function* logoutUser() {
  try {

   // clearSessionManually();
   localStorage.clear();
   // La prochaine ouverture devra revalider la session aupres du serveur.
   resetSessionCheck();
    if (process.env.REACT_APP_DEFAULTAUTH !== "firebase") {
      yield put(logoutUserSuccess(LOGOUT_USER, true));
    }
  } catch (error) {
    yield put(apiError(LOGOUT_USER, error));
  }
}


function* authSaga() {
  yield takeEvery(LOGIN_USER, loginUser);
  yield takeEvery(LOGOUT_USER, logoutUser);
}

export default authSaga;
